const APP_NAME = 'EventQ Agent';

/** Loose view of the env so a missing or outdated file cannot throw. */
export type DocumentTitleEnvironment = {
  production?: boolean;
  name?: unknown;
};

/** Browser tab title. Production omits the environment; every other named build includes it. */
export function eventqDocumentTitle(
  env: DocumentTitleEnvironment | null | undefined,
): string {
  const name = typeof env?.name === 'string' ? env.name.trim() : '';

  // A hosted build left on the local env file must not advertise itself as LOCAL.
  if (!name || name === 'prod' || (name === 'local' && env?.production === true)) {
    return APP_NAME;
  }

  return `${APP_NAME} - ${name.toUpperCase()}`;
}
